import {Box, Button, Stack, Typography} from '@mui/material';
import {useLegalDocument} from '@mybake/ui/hooks/useLegalDocument';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';
import {landingUrl} from '../../common/landingUrl';

export default function AuthFooter() {
    const {t} = useAppTranslation();
    const documents = useLegalDocument();
    const footerLinks = [
        {key: 'terms', path: '/pl/regulamin'},
        {key: 'privacy', path: '/pl/polityka-prywatnosci'},
        {key: 'contact', path: '/pl/kontakt'},
    ] as const;
    return <>
            <Stack component="footer" alignItems="center" spacing={1.5} sx={{mt: 4, pt: 3, borderTop: 1, borderColor: 'divider'}}>
                <Box component="nav" sx={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: .5}}>
                    {footerLinks.map(({key, path}) => {
                        const href = new URL(path, landingUrl).href;
                        const label = String(t(`landing:legal.${key}`));
                        return <Button key={key} component="a" href={documents.hrefFor(href)} onClick={documents.remember}>{label}</Button>;
                    })}
                </Box>
                <Box component="img" src={`${process.env.PUBLIC_URL}/branding/mybake-wordmark-3200px.png`} alt="MyBake.pro" width={3200} height={712} sx={{display: 'block', width: 120, maxWidth: '100%', height: 'auto'}}/>
                <Typography variant="body2" color="text.secondary">© 2026 MyBake</Typography>
            </Stack>
    </>;
}
